export default __webpack_public_path__ + "static/media/human2.ebae51ec.png";